
<div class="rfp-ratings-social-share">
  <slot></slot>
</div>
